import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

export function DesktopDeviceRedirect() {
  const params = useParams<{ device_id: string }>();

  return <Navigate replace to={`/devices/${params.device_id}`} />;
}
